import type { SiteConfig } from '@/types'
import { getOrigin } from '@/lib/window'

export const siteConfig: SiteConfig = {
    name: 'CaveDL',
    description: 'Download TikTok, Instagram, X, Facebook and Pinterest videos in seconds. Free, unlimited and right in your browser.',
    url: getOrigin(),
    ogImage: 'https://cavedl.cdn.modulify.website/images/og-image.png',
    creator: 'cavemanxx',
    links: {
        telegramBot: 'https://t.me/cavedlbot',
        github: 'https://github.com/EMMANUEL-SUNMBOLA',
        x: 'https://x.com/CaveDl'
    }
}

export const navLinks = [
    { label: 'How it works', href: '/#how-it-works' },
    { label: 'Plans', href: '/#plans' },
    { label: 'FAQ', href: '/#faq' }
]
